import moment from 'moment'
import { getTemplate } from './supapress-v3-utilities'
import { generalTranslations, collectionsTranslations } from '../utilities'

class SupapressV3Filters {
  constructor (SupapressV3Search) {
    this.SupapressV3Search = SupapressV3Search
    this.generalTranslations = generalTranslations()
    this.collectionsTranslations = collectionsTranslations()
  }

  setupHierarchicalMenuFilter () {
    const searchFilters = this.SupapressV3Search.searchWrapperContainer.querySelector('.js-supapress-v3-search-filter--all-subject')

    if (!searchFilters) {
      return
    }

    return this.SupapressV3Search.bookSearch.widgets.hierarchicalMenuFilter({
      container: searchFilters,
      operator: 'or',
      limit: 30,
      autoHide: false,
      collapsible: {
        collapsed: false
      },
      resultHandler: item => {
        return item
      },
      templates: {
        header: 'Subject',
        item: getTemplate('js-supapress-v3-search-filters')
      }
    })
  }

  setupClearAllFiltersButton () {
    const clearAllButton = this.SupapressV3Search.searchWrapperContainer.querySelector('.js-supapress-v3-clear-all-filters')

    if (!clearAllButton) {
      return
    }

    // translate clear all filters
    let label = 'Clear All Filters'
    if (this.generalTranslations.search.clear_all_filters) {
      label = this.generalTranslations.search.clear_all_filters
    }

    this.SupapressV3Search.bookSearch.addWidget(
      this.SupapressV3Search.bookSearch.widgets.clearAll({
        container: clearAllButton,
        label,
        classes: {
          button: 'supafolio-clear-all__button'
        }
      })
    )
  }

  setupPriceFilter () {
    const filter = this.SupapressV3Search.searchWrapperContainer.querySelector('.js-supapress-v3-search-filter--price')

    if (!filter) {
      return
    }

    this.SupapressV3Search.bookSearch.addWidget(
      this.SupapressV3Search.bookSearch.widgets.numericRefinementFilter({
        container: filter,
        attribute: 'prices.GBP',
        limit: 10,
        collapsible: {
          collapsed: false
        },
        filters: [
          { name: 'All' },
          { end: 7.48, name: 'less than £7.49' },
          { start: 7.49, end: 7.49, name: 'exactly £7.49' },
          { start: 7.50, name: 'more than £7.49' }
        ],
        templates: {
          header: 'Prices'
        }
      })
    )
  }

  setupFilters () {
    if (window.theme.settings.filtersOptions === '') {
      return
    }

    let moreLabel = 'Show more'
    if (this.collectionsTranslations.general.see_more) {
      moreLabel = this.collectionsTranslations.general.see_more
    }
    let lessLabel = 'Show less'
    if (this.collectionsTranslations.general.see_less) {
      lessLabel = this.collectionsTranslations.general.see_less
    }

    const filtersObject = Object.fromEntries(window.theme.settings.filtersOptions.split(',').map(s => s.split(':')))

    Object.keys(filtersObject).forEach((filter) => {
      const filterElement = this.SupapressV3Search.searchWrapperContainer.querySelector(`.js-supapress-v3-search-filter--${filter}`)

      if (!filterElement) {
        return
      }

      let sortBy = ['isRefined', 'name:asc']
      if (filtersObject[filter].includes('date_by_month')) {
        sortBy = (a, b) => {
          const momentLocale = window.theme.settings.shopLocale ? window.theme.settings.shopLocale.toLowerCase() : 'en'
          moment.locale(momentLocale)
          const aDate = moment(a.name, 'MMMM YYYY')
          const bDate = moment(b.name, 'MMMM YYYY')
          return bDate - aDate
        }
      }

      this.SupapressV3Search.bookSearch.addWidget(
        this.SupapressV3Search.bookSearch.widgets.refinementFilter({
          container: filterElement,
          attribute: `${filtersObject[filter]}`,
          sortBy: sortBy,
          autoHide: true,
          limit: 10,
          showMore: {
            open: false,
            moreLabel,
            lessLabel
          },
          collapsible: {
            collapsed: false
          },
          classes: {
            collapsible: 'collapsible-trigger collapsible-trigger-btn tag-list__header'
          },
          operator: 'or',
          resultHandler: item => {
            item.name = item.name.toLowerCase()
            return item
          },
          templates: {
            header: `${filter}<span class="collapsible-trigger__icon collapsible-trigger__icon--open">
                                            <svg aria-hidden="true" focusable="false" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg>
                                        </span>`,
            item: getTemplate('js-supapress-v3-search-filters')
          }
        })
      )
    })

    return this.SupapressV3Search.bookSearch.widgets
  }
}

export default SupapressV3Filters
